<template>
  <div class="feedback-container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>服务中心</el-breadcrumb-item>
        <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">意见反馈</div>
    <!-- 反馈表单部分 -->
    <el-card class="feedback-form">
      <el-form :model="feedbackForm" ref="feedbackForm" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="feedbackForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            v-model="feedbackForm.description"
            :rows="4"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <div class="form-footer">
          <p>感谢您宝贵的使用感受和改进意见</p>
        </div>
        <el-form-item label="附件">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="handleUpload"
            :on-success="handleUploadSuccess"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :before-remove="beforeRemove"
            multiple
            :limit="3"
            :on-exceed="handleExceed"
            :file-list="fileList"
            accept=".jpg,.jpeg,.png,.gif"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png/gif文件，且不超过5MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="clearForm">清空</el-button>
          <!-- <el-button @click="testNotification">测试通知</el-button> -->
          <!-- <el-button @click="getContacts">获取通讯录成员</el-button>
          <el-button @click="getAuthUrl">获取授权链接</el-button>
          <el-button @click="getUserInfoAuth">获取用户信息</el-button> -->
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 反馈列表部分 -->
    <el-card class="feedback-list">
      <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="title" label="标题" width="150"></el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="submitter" label="提交人" width="100"></el-table-column>
        <el-table-column prop="submit_time" label="提交时间" width="160">
          <template slot-scope="scope">
            {{ formatTime(scope.row.submit_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="reply" label="答复意见" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.reply || '暂无答复' }}
          </template>
        </el-table-column>
        <el-table-column prop="reply_time" label="答复时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.reply_time ? formatTime(scope.row.reply_time) : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="attachments" label="附件" width="120" align="center">
          <template #default="scope">
            <div
              v-if="scope.row.attachments && scope.row.attachments.length > 0"
              class="image-thumbnail-container"
            >
              <el-image
                v-for="(img, index) in scope.row.attachments.slice(0, 1)"
                :key="index"
                :src="img"
                :preview-src-list="scope.row.attachments"
                fit="cover"
                class="image-thumbnail"
                preview-teleported
                :close-on-click-modal="true"
              ></el-image>
              <span v-if="scope.row.attachments.length > 1" class="image-count"
                >+{{ scope.row.attachments.length }}</span
              >
            </div>
            <span v-else>无图片</span>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetail(scope.row)"
              >查看详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleReply(scope.row)"
              v-if="scope.row.status !== '已完成' && isAuthorizedUser()"
              >答复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 答复抽屉 -->
    <el-drawer
      title="答复反馈"
      :visible.sync="replyDrawerVisible"
      direction="rtl"
      size="30%"
      :destroy-on-close="true"
    >
      <div class="drawer-content" v-if="currentReply">
        <el-form :model="replyForm" ref="replyForm" :rules="replyRules" label-width="80px">
          <el-form-item label="反馈标题" class="reply-title">
            <span>{{ currentReply.title }}</span>
          </el-form-item>
          <el-form-item label="答复意见" prop="reply">
            <el-input
              type="textarea"
              v-model="replyForm.reply"
              :rows="4"
              placeholder="请输入答复意见"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitReply">提交答复</el-button>
            <el-button @click="replyDrawerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <!-- 详情抽屉 -->
    <el-drawer
      title="反馈详情"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="30%"
      :destroy-on-close="true"
    >
      <div class="drawer-content" v-if="currentDetail">
        <div class="detail-item">
          <span class="label">标题：</span>
          <span>{{ currentDetail.title }}</span>
        </div>
        <div class="detail-item">
          <span class="label">描述：</span>
          <span>{{ currentDetail.description }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交人：</span>
          <span>{{ currentDetail.submitter }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交时间：</span>
          <span>{{ formatTime(currentDetail.submit_time) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">状态：</span>
          <el-tag :type="getStatusType(currentDetail.status)">{{ currentDetail.status }}</el-tag>
        </div>
        <div class="detail-item">
          <span class="label">答复意见：</span>
          <span>{{ currentDetail.reply || '暂无答复' }}</span>
        </div>
        <div class="detail-item" v-if="currentDetail.reply_time">
          <span class="label">答复时间：</span>
          <span>{{ formatTime(currentDetail.reply_time) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">附件：</span>
          <div
            class="attachments-preview"
            v-if="currentDetail.attachments && currentDetail.attachments.length > 0"
          >
            <el-image
              v-for="(img, index) in currentDetail.attachments"
              :key="index"
              :src="img"
              :preview-src-list="currentDetail.attachments"
              fit="cover"
              class="detail-image"
              preview-teleported
            ></el-image>
          </div>
          <span v-else>无图片</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  postFeedback,
  getFeedbackList,
  uploadAttachment,
  replyFeedback,
  testWechatMessage,
  getOauthUrl,
  getUserInfo,
  oauthCallback,
} from '@/api/feedback';

export default {
  name: 'Feedback',
  data() {
    return {
      feedbackForm: {
        id: null, // 添加 id 字段
        title: '',
        description: '',
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }],
      },
      replyForm: {
        id: null,
        reply: '',
      },
      replyRules: {
        reply: [{ required: true, message: '请输入答复意见', trigger: 'blur' }],
      },
      replyDrawerVisible: false,
      currentReply: null,
      drawerVisible: false,
      currentDetail: null,
      fileList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      imageTypes: ['image/jpeg', 'image/png', 'image/gif'],
      maxFileSize: 5, // 文件大小限制，单位MB
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getUserInfoAuth() {
      let params = {
        code: 'NNHxN_NshvXhNh6GLRAaNuE-YxXEWCM0OUIZ6vW-QKo',
      };
      oauthCallback(params).then((res) => {
      });
    },
    getAuthUrl() {
      let params = {
        redirect_uri: 'https://fcops.prod.fontalcloud.com/',
        response_type: 'code',
      };
      getOauthUrl(params).then((res) => {
      });
    },
    // 获取列表数据
    getList() {
      this.loading = true;
      getFeedbackList({
        skip: (this.currentPage - 1) * this.pageSize,
        limit: this.pageSize,
      })
        .then((res) => {
          if (res.status === 200) {
            // 处理返回的数据，确保attachments字段为数组格式
            this.tableData = res.data.data.list.map((item) => ({
              ...item,
              attachments: this.getAttachmentList(item.attachments),
            }));
            this.total = res.data.data.total;
            console.log(this.tableData);
          }
        })
        .catch((err) => {
          this.$message.error(`获取列表失败: ${err.message || '未知错误'}`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getContacts() {
      let params = {
        userid: 'linda.Han',
      };
      getUserInfo(params).then((res) => {
      });
    },
    // 修改文件上传相关方法
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.fileList = fileList;
        this.$message.success('上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },

    // 修改提交表单方法
    submitForm() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            // 构建请求参数
            const formData = new FormData();
            formData.append('title', this.feedbackForm.title);
            formData.append('description', this.feedbackForm.description);
            formData.append('submitter', localStorage.getItem('UserId') || '匿名用户');

            // 添加文件到FormData
            if (this.fileList.length > 0) {
              this.fileList.forEach((file) => {
                formData.append('files', file.raw);
              });
            }

            // 提交反馈和附件
            const res = await postFeedback(formData);

            if (res.status === 200) {
              this.$message.success('提交成功');
              this.resetForm();
              this.getList(); // 刷新列表
            } else {
              throw new Error(res.message || '提交失败');
            }
          } catch (err) {
            this.$message.error(`提交失败: ${err.message || '未知错误'}`);
          } finally {
            this.loading = false;
          }
        }
      });
    },

    testNotification() {
      testWechatMessage().then((res) => {});
    },

    // 修改分页方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    resetForm() {
      this.$refs.feedbackForm.resetFields();
      this.fileList = [];
    },
    clearForm() {
      this.resetForm();
      this.$message.info('已清空表单数据');
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file) {
      // TODO: 实现文件预览逻辑
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 张图片`);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // TODO: 重新获取列表数据
      this.getList();
    },
    // 格式化时间方法
    formatTime(time) {
      if (!time) return '';
      return new Date(time).toLocaleString();
    },
    // 处理文件上传
    handleUpload(options) {
      const { file } = options;

      // 校验文件
      if (!this.beforeUpload(file)) {
        return;
      }

      // 将文件添加到fileList
      this.fileList.push({
        name: file.name,
        raw: file,
      });

      // 触发上传成功回调
      options.onSuccess();
    },

    // 上传前校验
    beforeUpload(file) {
      // 校验文件类型
      if (!this.imageTypes.includes(file.type)) {
        this.$message.error('只能上传JPG/PNG/GIF格式的图片！');
        return false;
      }

      // 校验文件大小
      const isLtMaxSize = file.size / 1024 / 1024 < this.maxFileSize;
      if (!isLtMaxSize) {
        this.$message.error(`上传图片大小不能超过 ${this.maxFileSize}MB!`);
        return false;
      }
      return true;
    },
    // 获取附件列表
    getAttachmentList(attachments) {
      if (!attachments) return [];
      try {
        // 如果是字符串，尝试处理
        if (typeof attachments === 'string') {
          // 移除可能存在的空白字符
          const cleanStr = attachments.trim();
          // 检查是否包含逗号，如果包含则按逗号分割
          if (cleanStr.includes(',')) {
            return cleanStr
              .split(',')
              .map((url) => url.trim())
              .filter((url) => url && this.isValidUrl(url));
          }
          // 如果是单个URL，直接返回包含该URL的数组
          return this.isValidUrl(cleanStr) ? [cleanStr] : [];
        }
        // 如果已经是数组，直接返回
        if (Array.isArray(attachments)) {
          return attachments;
        }
        return [];
      } catch (e) {
        console.error('解析附件列表失败:', e);
        return [];
      }
    },
    // 检查是否是有效的URL
    isValidUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (_) {
        return false;
      }
    },
    // 获取附件数量
    getAttachmentCount(attachments) {
      const list = this.getAttachmentList(attachments);
      return list.length;
    },
    // 判断文件是否为图片
    isImageFile(file) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
      return imageExtensions.some((ext) => file.toLowerCase().endsWith(ext));
    },
    // 获取图片预览列表
    getImagePreviewList(attachments) {
      const list = this.getAttachmentList(attachments);
      return list.filter((file) => this.isImageFile(file));
    },
    // 判断当前用户是否有权限答复
    isAuthorizedUser() {
      const authorizedUsers = ['韩林达', '周德明', '何文卷', '陈伟锋'];
      const currentUser = localStorage.getItem('UserId') || '';
      return authorizedUsers.includes(currentUser);
    },

    // 获取状态标签类型
    getStatusType(status) {
      const statusMap = {
        待处理: 'warning',
        处理中: 'primary',
        已完成: 'success',
        已关闭: 'info',
      };
      return statusMap[status] || 'info';
    },
    handleViewDetail(row) {
      this.currentDetail = row;
      this.drawerVisible = true;
    },
    // 处理答复按钮点击
    handleReply(row) {
      this.currentReply = row;
      this.replyForm.id = row.id;
      this.replyForm.reply = '';
      this.replyDrawerVisible = true;
    },
    // 提交答复
    submitReply() {
      this.$refs.replyForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await replyFeedback({
              id: this.replyForm.id,
              reply: this.replyForm.reply,
              status: '已完成',
            });
            if (res.status === 200) {
              this.$message.success('答复成功');
              this.replyDrawerVisible = false;
              this.getList();
            } else {
              throw new Error(res.message || '答复失败');
            }
          } catch (err) {
            this.$message.error(`答复失败: ${err.message || '未知错误'}`);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-container {
  padding: 20px;

  .drawer-content {
    padding: 20px;

    .detail-item {
      margin-bottom: 15px;

      .label {
        display: inline-block;
        width: 80px;
        text-align: right;
        font-weight: bold;
        margin-right: 10px;
      }

      .attachments-preview {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .detail-image {
          width: 100px;
          height: 100px;
          border-radius: 4px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.feedback-container {
  padding: 20px;

  .image-stack-preview {
    display: flex;
    align-items: center;
    padding: 4px;

    .preview-image-inline {
      width: 50px;
      height: 50px;
      border-radius: 6px;
      object-fit: cover;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        transform: translateY(-5px) !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
    }

    .file-link {
      margin-left: 8px;
    }
  }

  .feedback-form {
    margin-bottom: 20px;
    padding-top: 20px;
    .form-header {
      margin-bottom: 20px;
      h3 {
        margin: 0;
        font-size: 18px;
        color: #303133;
      }
    }

    .form-footer {
      text-align: center;
      color: #909399;
    }
  }

  .feedback-list {
    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .title-en {
    margin: 10px 0;
    padding-left: 10px;
    border-left: 3px solid #219aff;
    font-weight: normal;
  }
}
.image-thumbnail {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
}
.image-count {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 0 0 4px 0;
}
.image-thumbnail-container {
  position: relative;
  display: inline-block;
}
</style>

